import React, { useState } from 'react'
import { Button } from 'reactstrap'
import { Divider, Tooltip } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone } from '@fortawesome/free-solid-svg-icons'

import NewCallLogModal from '../containers/CallLogs/partials/NewCallLogModal'

export default function CallButton({ customer, invoiceId, customerId, reload, disabled }) {
	const [visible, setVisible] = useState(false)

	return (
		<React.Fragment>
			<Tooltip title="Realizar Llamada">
				<Button
					size='sm'
					color={disabled ? 'dark' : 'primary'}
					disabled={disabled}
					outline
					onClick={() => setVisible(true)}
				>
					<FontAwesomeIcon icon={faPhone} />
				</Button>
			</Tooltip>
			<Divider type='vertical' />
			{ visible && (
				<NewCallLogModal
					visible
					onClose={() => setVisible(false)}
					customer={customer}
					invoiceId={invoiceId}
					customerId={customerId}
					reload={reload}
				/>
			)}
		</React.Fragment>
	)
}
